import { render, staticRenderFns } from "./SizeChooser.vue?vue&type=template&id=424b589f&scoped=true&"
import script from "./SizeChooser.vue?vue&type=script&lang=js&"
export * from "./SizeChooser.vue?vue&type=script&lang=js&"
import style0 from "./SizeChooser.vue?vue&type=style&index=0&id=424b589f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424b589f",
  null
  
)

export default component.exports